import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      margin: "1em",
      borderRadius: "37px",
      boxShadow: "7px 6px 30px 3px rgb(0 0 0 / 77%)",
    },
    smartphone: {
      position: "relative",
      margin: "auto",
      border: "16px solid black",
      borderTopWidth: "60px",
      borderBottomWidth: "60px",
      borderRadius: "36px",
      width: "280px",
      height: "600px",
      background: "white",
      overflow: "visible",
      "&:after": {
        content: '""',
        display: "block",
        width: "35px",
        height: "35px",
        position: "absolute",
        left: "50%",
        bottom: "-65px",
        transform: "translate(-50%, -50%)",
        background: "#333",
        borderRadius: "50%",
      },
      "&:before": {
        content: '""',
        display: "block",
        width: "60px",
        height: "5px",
        position: "absolute",
        top: "-30px",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#333",
        borderRadius: "10px",
      },
    },
    content: {
      width: "100%",
      height: "100%",
      padding: "10px",
      backgroundImage: "linear-gradient(to bottom, #673368, #CF939C)",
      overflow: "scroll",
    },
  }),
);

const useSmartphoneEventPreview = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useSmartphoneEventPreview as default };
